import _ from 'lodash';
import { setDate, format } from 'date-fns';

import { ISO_DATE_FORMAT } from '@constants/dates';

import {
  convertPortalToProviderAccount,
  convertCentsAmountToDollarsAmount,
} from './fdp-to-yodlee-transforms';

/**
 * Transforms a financial data response from the FDP backend with portals and financial accounts to a legacy Yodlee provider
 * accounts and yodlee account data model compatible with the existing clients
 */
export const transformFinancialDataProfileToLegacyDataShape = (
  financialDataResponse,
) => {
  const financialPortals =
    financialDataResponse?.linkedFinancialPortals?.portals ?? [];
  const financialAccounts =
    financialDataResponse?.financialAccounts?.accounts ?? [];
  const accountSums = financialDataResponse?.financialAccountTypeSums ?? {};

  const financialAccountsByPortalId = _.groupBy(
    financialAccounts,
    (financialAccount) => financialAccount?.financialPortal?.id,
  );

  const providerAccounts = financialPortals.map((portal) =>
    convertPortalToProviderAccount(
      portal,
      financialAccountsByPortalId?.[portal?.id] ?? [],
    ),
  );

  return {
    is_fdp_shim: true,
    provider_accounts: providerAccounts,
    sum_assets: convertCentsAmountToDollarsAmount(accountSums?.assets),
    sum_bank_balances: convertCentsAmountToDollarsAmount(accountSums?.banks),
    sum_credit_card_balances: convertCentsAmountToDollarsAmount(
      accountSums?.creditCards,
    ),
    sum_debts: convertCentsAmountToDollarsAmount(accountSums?.debts),
    sum_investment_balances: convertCentsAmountToDollarsAmount(
      accountSums?.investments,
    ),
    sum_loan_balances: convertCentsAmountToDollarsAmount(accountSums?.loans),
  };
};

export const convertDaySpendingListToDateSpendingMap = (
  daySpendingList = [],
  originalDate: Date,
) => {
  const date = new Date(originalDate);

  return daySpendingList.reduce((acc, { dayOfTheMonth, amount }) => {
    const newDate = setDate(date, dayOfTheMonth);
    return {
      ...acc,
      [format(newDate, ISO_DATE_FORMAT)]: amount,
    };
  }, {});
};
